import React, { useEffect, useState } from 'react';
import { testimonials } from '../mock';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI(v => (v + 1) % testimonials.length), 6000);
    return () => clearInterval(t);
  }, []);

  const t = testimonials[i];
  const go = (d) => setI(v => (v + d + testimonials.length) % testimonials.length);

  return (
    <section className="relative py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="text-xs tracking-[0.3em] text-sky-600 font-semibold uppercase mb-3">Client Stories</div>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-slate-900 leading-tight">
            The world’s finest, <span className="water-text">upgraded</span>.
          </h2>
        </div>

        <div className="relative rounded-[3rem] bg-gradient-to-br from-sky-50 to-cyan-50 border border-sky-100 p-8 lg:p-16 overflow-hidden">
          <Quote className="absolute top-8 left-8 w-24 h-24 text-sky-200" strokeWidth={1} />
          <div key={t.id} className="slide-enter relative z-10 max-w-3xl mx-auto text-center">
            <p className="font-display text-2xl md:text-3xl leading-snug text-slate-800 font-medium">
              “{t.quote}”
            </p>
            <div className="mt-8 flex items-center justify-center gap-4">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-sky-400 to-cyan-600 flex items-center justify-center text-white font-display font-bold text-xl">
                {t.name.charAt(0)}
              </div>
              <div className="text-left">
                <div className="font-semibold text-slate-900">{t.name}</div>
                <div className="text-sm text-slate-500">{t.role} • {t.company}</div>
              </div>
            </div>
          </div>

          <div className="mt-10 flex items-center justify-center gap-4">
            <button onClick={() => go(-1)} className="w-11 h-11 rounded-full bg-white border border-sky-200 hover:bg-sky-100 flex items-center justify-center transition-colors" aria-label="prev">
              <ChevronLeft className="w-5 h-5 text-slate-700" />
            </button>
            <div className="flex gap-2">
              {testimonials.map((tt, idx) => (
                <button key={tt.id} onClick={() => setI(idx)} className={`h-1.5 rounded-full transition-all ${idx === i ? 'w-8 bg-sky-500' : 'w-3 bg-sky-200'}`} />
              ))}
            </div>
            <button onClick={() => go(1)} className="w-11 h-11 rounded-full bg-white border border-sky-200 hover:bg-sky-100 flex items-center justify-center transition-colors" aria-label="next">
              <ChevronRight className="w-5 h-5 text-slate-700" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
